import React from 'react';
import styled from 'styled-components';
import {Detail, Icon, Pill, PillVariant} from '@forecast-it/design-system';
import {FEATURE_FLAG_CARD_BORDER, FEATURE_FLAG_NEUTRAL_FILL, featureFlagCardSurface} from '../featureFlagSurface';
import {RolloutDirectory} from '../rollout/featureFlagRolloutDirectory';
import {CompanyMembershipTable} from './CompanyMembershipTable';
import {buildMembershipRows, MembershipIndex} from './featureFlagLists';

const Card = styled.div`
	${featureFlagCardSurface}
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	padding: 14px 18px;
	border-bottom: 1px solid ${FEATURE_FLAG_CARD_BORDER};
`;

const InfoBanner = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 16px 18px;
	background: ${FEATURE_FLAG_NEUTRAL_FILL};
	border-bottom: 1px solid ${FEATURE_FLAG_CARD_BORDER};
`;

const InfoIcon = styled.span`
	flex: none;
	margin-top: 1px;
`;

const BANNER_COPY =
	'Companies join the beta program themselves — the list cannot be edited here. Adding all beta companies to a flag bypasses the percentage and is done from the rollout dialog.';

export interface BetaProgramTabProps {
	/** Encoded company ids currently opted into the beta programme. */
	betaCompanyIds: readonly string[];
	index: MembershipIndex;
	directory: RolloutDirectory;
}

/**
 * The beta programme list, read only: companies opt in themselves through a customer-facing flow, and
 * Mission Control only reads `company_extension.beta_opt_in`. No picker, no remove control — nothing on
 * this tab can change membership.
 */
export function BetaProgramTab({betaCompanyIds, index, directory}: BetaProgramTabProps): JSX.Element {
	return (
		<Card>
			<Header>
				<Pill variant={PillVariant.NEUTRAL}>Read only</Pill>
			</Header>
			<InfoBanner>
				<InfoIcon>
					<Icon icon="info" size="s" />
				</InfoIcon>
				<Detail color="medium">{BANNER_COPY}</Detail>
			</InfoBanner>
			<CompanyMembershipTable
				rows={buildMembershipRows(betaCompanyIds, index, directory, {kind: 'beta'})}
				emptyTitle="No companies in the beta program"
				emptyHint="Companies join from their own company settings — nothing to add here."
			/>
		</Card>
	);
}
